import { isLocalhost } from '@/lib/utils/devUtils.js'

const isDev = isLocalhost()

export const appConfigs = {
  // -----------------------------------
  // DO NOT PUT SENSITIVE DATA HERE
  // USE .env files for that
  // These vars are exposed to the client
  // -----------------------------------

  USE_DEV_API_IN_DEV:
    (import.meta.env.VITE_USE_DEV_API_IN_DEV ?? 'false') === 'true',

  USE_DEV_STATIC_IN_DEV:
    (import.meta.env.VITE_USE_DEV_STATIC_IN_DEV ?? 'false') === 'false',

  USE_SENTRY_IN_DEV:
    (import.meta.env.VITE_USE_SENTRY_IN_DEV ?? 'true') === 'true',
  API_DOMAIN: import.meta.env.VITE_API_DOMAIN ?? 'https://api.selfwise.io',
  STATIC_DOMAIN: 'https://static.selfwise.io',
  DEV_API_DOMAIN:
    import.meta.env.VITE_DEV_API_DOMAIN ?? 'http://localhost:5588',

  get apiUrl() {
    return isDev && this.USE_DEV_API_IN_DEV
      ? this.DEV_API_DOMAIN
      : this.API_DOMAIN
  },
  get staticDomain() {
    return isDev && this.USE_DEV_STATIC_IN_DEV
      ? this.DEV_API_DOMAIN
      : this.STATIC_DOMAIN
  },
  // AGORA_APP_ID: "5d413b3e17454228905ae4aa7a663723", //selfwise v1
  AGORA_APP_ID: 'f30692374bc14ad9bba1240492f145d7', // selfwise v2 https://console.agora.io/v2/project-management
  AGORA_LOG_LEVEL: 3, // 0: debug, 1: info, 2: warning, 3: error, 4: none
  SUPA_ID: 'vcmfqtvbiywiatqzlbqu',
  SUPA_CLIENTTOKEN_URL:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZjbWZxdHZiaXl3aWF0cXpsYnF1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzgzMzMxODksImV4cCI6MjA1MzkwOTE4OX0.rtSc6nIy1fhFxOtjIGaepxzpjZHOEkMMAtXPY2ljmUg',

  // Stripe Configuration
  USE_TEST_STRIPE_ON_LOCALHOST:
    (import.meta.env.VITE_USE_TEST_STRIPE_ON_LOCALHOST ?? 'true') === 'true',

  // Stripe Public Keys
  STRIPE_TEST_PUBLIC_KEY: 'pk_test_51Qqa8MJ4ONeBNu5I7DyQCD7TOh44eserBULtPXLv6MXAHjbF6iV42pojpXsAwrykDYbjv46jbfbed9Ml9COb617l0011KFhOgu',
  STRIPE_LIVE_PUBLIC_KEY: 'pk_live_51Qqa8MJ4ONeBNu5If8aJFpcHWXmsW68aaxaDJvjyTz7nAxanppUv8bC1v9XGO4EpQYlUTURgffBGiCZorArBZ6AO00Sggmn4GQ',

  // Stripe Price IDs
  STRIPE_TEST_MONTHLY_PRICE_ID: 'price_1RNykcJ4ONeBNu5IVpm4Dvgk',
  STRIPE_LIVE_MONTHLY_PRICE_ID: 'price_1RNygWJ4ONeBNu5IrYNSUu9P',
  STRIPE_TEST_ANNUAL_PRICE_ID: 'price_1RNylEJ4ONeBNu5IX3vC7tSh',
  STRIPE_LIVE_ANNUAL_PRICE_ID: 'price_1RNyifJ4ONeBNu5Iy0INDJh2',
  STRIPE_TEST_LIFETIME_PRICE_ID: 'price_1RU8CTJ4ONeBNu5IorUI96ks',
  STRIPE_LIVE_LIFETIME_PRICE_ID: 'price_1RU8ASJ4ONeBNu5IRuTinxBN',

  // Dynamic Stripe configuration getters
  get useTestStripe() {
    return isDev && this.USE_TEST_STRIPE_ON_LOCALHOST
  },
  get stripePublicKey() {
    return this.useTestStripe ? this.STRIPE_TEST_PUBLIC_KEY : this.STRIPE_LIVE_PUBLIC_KEY
  },
  get stripeMonthlyPriceId() {
    return this.useTestStripe ? this.STRIPE_TEST_MONTHLY_PRICE_ID : this.STRIPE_LIVE_MONTHLY_PRICE_ID
  },
  get stripeAnnualPriceId() {
    return this.useTestStripe ? this.STRIPE_TEST_ANNUAL_PRICE_ID : this.STRIPE_LIVE_ANNUAL_PRICE_ID
  },
  get stripeLifetimePriceId() {
    return this.useTestStripe ? this.STRIPE_TEST_LIFETIME_PRICE_ID : this.STRIPE_LIVE_LIFETIME_PRICE_ID
  },

  // Audio Recording Configuration
  SAVE_AUDIO_LOCALLY: (import.meta.env.VITE_SAVE_AUDIO_LOCALLY ?? 'false') === 'true',
}
